import API from "./index";

class AuditoriaItemBemPermanenteService {
  constructor() {
    this.path = 'api/auditoria-item-bem-permanente';
  }

  async listarAuditorias({ codPessoa, codComissao, codDepartamento, codLocalizacao, finalizado, dataDe, dataAte, page = 0, size = 5 }) {
    const params = { page, size };

    if (codPessoa !== undefined) params.codPessoa = codPessoa;
    if (codComissao !== undefined) params.codComissao = codComissao;
    if (codDepartamento !== undefined) params.codDepartamento = codDepartamento;
    if (codLocalizacao !== undefined) params.codLocalizacao = codLocalizacao;
    if (finalizado !== undefined) params.finalizado = finalizado;
    if (dataDe !== undefined) params.dataDe = dataDe;
    if (dataAte !== undefined) params.dataAte = dataAte;

    return API.get(this.path, { params });
  }

  async buscarPorId(id) {
    return API.get(`${this.path}/simple/${id}`);
  }

  async criarAuditoria(auditoriaData) {
    return API.post(this.path, auditoriaData);
  }

  async atualizarAuditoria(id, auditoriaData) {
    return API.put(`${this.path}/${id}`, auditoriaData);
  }

  async finalizarAuditoria(id, auditoriaData) {
    return API.post(`${this.path}/${id}/finalizar`, auditoriaData);
  }

  async removerAuditoria(id) {
    return API.delete(`${this.path}/${id}`);
  }

  async getItemsByDepartamentoAndLocalizacao({ codDepartamento, codsDepartamentos, codLocalizacao, page = 0, size = 20 }) {
    const params = { codDepartamento, codsDepartamentos, codLocalizacao, page, size };
    return API.get(`${this.path}/itens-disponiveis-resumo`, { params });
  }

  async getProximosItensDaAuditoria(auditoriaId, page = 0, size = 20) {
    const params = { page, size };
    return API.get(`${this.path}/${auditoriaId}/itens-proximos`, { params });
  }
}

export default new AuditoriaItemBemPermanenteService();
